import { createThunkEffect } from "../../utilities/ActionUtility";
import * as UseCasesEffect from "./UseCasesEffect";

// use case categories
export const REQUEST_ALL_CATEGORIES = "UseCasesEffect.REQUEST_ALL_CATEGORIES";
export const REQUEST_ALL_CATEGORIES_FINISHED = "UseCasesEffect.REQUEST_ALL_CATEGORIES_FINISHED";

export function requestAllCategories() {
    return async dispatch => {
        await createThunkEffect(dispatch, REQUEST_ALL_CATEGORIES, UseCasesEffect.requestAllCategories);
    };
}

export const REQUEST_ADD_CATEGORY = "UseCasesEffect.REQUEST_ADD_CATEGORY";
export const REQUEST_ADD_CATEGORY_FINISHED = "UseCasesEffect.REQUEST_ADD_CATEGORY_FINISHED";

export function addCategory(category) {
    return async dispatch => {
        await createThunkEffect(dispatch, REQUEST_ADD_CATEGORY, UseCasesEffect.addCategory, category);
    };
}

export const REQUEST_UPDATE_CATEGORY = "UseCasesEffect.REQUEST_UPDATE_CATEGORY";
export const REQUEST_UPDATE_CATEGORY_FINISHED = "UseCasesEffect.REQUEST_UPDATE_CATEGORY_FINISHED";

export function updateCategory(id, category) {
    return async dispatch => {
        await createThunkEffect(dispatch, REQUEST_UPDATE_CATEGORY, UseCasesEffect.updateCategory, id, category);
    };
}

export const REQUEST_DELETE_CATEGORY = "UseCasesEffect.REQUEST_DELETE_CATEGORY";
export const REQUEST_DELETE_CATEGORY_FINISHED = "UseCasesEffect.REQUEST_DELETE_CATEGORY_FINISHED";

export function deleteCategory(id) {
    return async dispatch => {
        await createThunkEffect(dispatch, REQUEST_DELETE_CATEGORY, UseCasesEffect.deleteCategory, id);
    };
}

// use cases
export const REQUEST_ALL_USE_CASES = "UseCasesEffect.REQUEST_ALL_USE_CASES";
export const REQUEST_ALL_USE_CASES_FINISHED = "UseCasesEffect.REQUEST_ALL_USE_CASES_FINISHED";

export function requestAllUseCases() {
    return async dispatch => {
        await createThunkEffect(dispatch, REQUEST_ALL_USE_CASES, UseCasesEffect.requestAllUseCases);
    };
}

export const REQUEST_ADD_USE_CASE = "UseCasesEffect.REQUEST_ADD_USE_CASE";
export const REQUEST_ADD_USE_CASE_FINISHED = "UseCasesEffect.REQUEST_ADD_USE_CASE_FINISHED";

export function addUseCase(category) {
    return async dispatch => {
        await createThunkEffect(dispatch, REQUEST_ADD_USE_CASE, UseCasesEffect.addUseCase, category);
    };
}

export const REQUEST_UPDATE_USE_CASE = "UseCasesEffect.REQUEST_UPDATE_USE_CASE";
export const REQUEST_UPDATE_USE_CASE_FINISHED = "UseCasesEffect.REQUEST_UPDATE_USE_CASE_FINISHED";

export function updateUseCase(id, category) {
    return async dispatch => {
        await createThunkEffect(dispatch, REQUEST_UPDATE_USE_CASE, UseCasesEffect.updateUseCase, id, category);
    };
}

export const REQUEST_DELETE_USE_CASE = "UseCasesEffect.REQUEST_DELETE_USE_CASE";
export const REQUEST_DELETE_USE_CASE_FINISHED = "UseCasesEffect.REQUEST_DELETE_USE_CASE_FINISHED";

export function deleteUseCase(id) {
    return async dispatch => {
        await createThunkEffect(dispatch, REQUEST_DELETE_USE_CASE, UseCasesEffect.deleteUseCase, id);
    };
}
